import React from 'react'
import EasingMotion from './easing-motion'
import { bool } from 'prop-types'
import { spring } from 'react-motion'
import { textGap } from 'lib/text'
import colors from '../colors'
import { guardProps } from './validate'

import { FONT_FAMILY, FONT_LARGE, SPRING } from '../constants'

const LABEL_BOX_HEIGHT = 26
const LABEL_BOX_Y_OFFSET = LABEL_BOX_HEIGHT / 2
const LABEL_MARGIN = 18
const LABEL_PADDING = 24
const LABEL_STROKE_WIDTH = 6

const FONT = `${FONT_LARGE} ${FONT_FAMILY}`

class EasingLabel extends React.PureComponent {
  static defaultProps = {
    animate: true,
    margin: LABEL_MARGIN,
    fill: 'transparent',
    isHollow: false,
    opacity: 1,
    stroke: colors.lightGray
  }

  static contextTypes = {
    exported: bool
  }

  constructor(props, context) {
    super(props, context)
    this.isForExport = context.exported
  }

  getLabelWidth(textWidth) {
    return textWidth + LABEL_STROKE_WIDTH + LABEL_PADDING * 2
  }

  getAnchor() {
    const { x, label, width } = this.props

    let textWidth = this.getLabelWidth(textGap(label, n => n, FONT))

    return x + textWidth > width * 0.95 ? 'end' : 'start'
  }

  renderLabel({ x, y }) {
    const { label, fill, stroke, margin, opacity } = this.props

    let anchor = this.getAnchor()

    let dir = anchor === 'end' ? -1 : 1

    let textWidth = textGap(label, n => n, FONT)
    let labelWidth = this.getLabelWidth(textWidth)

    let labelX = x + margin * dir
    let labelY = y - LABEL_BOX_Y_OFFSET

    let textOpacity = this.isForExport ? 1 : opacity
    let frameOpacity = this.isForExport ? 0 : opacity

    let textX = (this.isForExport ? textWidth : labelWidth) * 0.5
    let strokeX = 0

    if (anchor === 'end') {
      labelX -= this.isForExport ? textWidth : labelWidth
      strokeX = labelWidth - LABEL_STROKE_WIDTH
    }

    if (labelX < LABEL_PADDING * 2) {
      labelY += LABEL_BOX_HEIGHT
      labelX = LABEL_PADDING * 2
    }

    return (
      <g
        className="easing-label non-interactive"
        fontFamily={FONT_FAMILY}
        fontSize={FONT_LARGE}
        transform={`translate(${labelX},${labelY})`}
      >
        <g opacity={frameOpacity}>
          {/* outer box */}
          <rect
            fill="#fff"
            width={labelWidth}
            height={LABEL_BOX_HEIGHT}
            stroke={stroke}
          />
          {/* outer box's inner stroke */}
          <rect
            x={strokeX}
            width={LABEL_STROKE_WIDTH}
            height={LABEL_BOX_HEIGHT}
            fill={fill}
          />
        </g>

        <text
          x={textX}
          dy="1em"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={colors.black}
          opacity={textOpacity}
        >
          {label}
        </text>
      </g>
    )
  }

  render() {
    const { animate, x, y, opacity } = this.props

    if (opacity <= 0 || guardProps(this, 'x', 'y')) {
      return null
    }

    if (!animate) {
      return this.renderLabel(this.props)
    }

    const style = {
      x: spring(x, SPRING),
      y: spring(y, SPRING)
    }

    return (
      <EasingMotion style={style} static={this.props}>
        {style => this.renderLabel(style)}
      </EasingMotion>
    )
  }
}

export default EasingLabel



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-label.js